import { Icon, IIconStyles } from '@fluentui/react';
import { forwardRef, HTMLAttributes, Ref } from 'react';

import { IComponent, IconName, IStyleFunctionOrObject } from '../../models/components.models';
import { iconStylesInfo } from '../../themes/themes';
import { useClassNames, useThemeStyles } from '../../utils/hooks';
import { singleOrArrayToArray } from '../../utils/utils';
import { ITooltipHostProps, TooltipHost } from '../TooltipHost/TooltipHost';
import { IInfoStyles, infoStylesDefault } from './Info.styles';

export interface IInfoProps extends IComponent<IInfoStyles>, HTMLAttributes<HTMLDivElement> {
  iconName?: string;
  iconStyles?: IStyleFunctionOrObject<IIconStyles> | IStyleFunctionOrObject<IIconStyles>[];
  isTooltip?: boolean;
  tooltipHostProps?: ITooltipHostProps;
}

interface IInfoClassNames {
  root: string;
  icon: string;
  text: string;
}

export const Info = forwardRef((props: IInfoProps, ref: Ref<HTMLDivElement>) => {
  const {
    className,
    styles,
    iconName = IconName.Info,
    iconStyles,
    children,
    isTooltip,
    tooltipHostProps,
    ...elementProps
  } = props;
  const classNames = useClassNames<Partial<IInfoStyles>, IInfoClassNames>(
    'Info',
    infoStylesDefault,
    styles,
    className,
    isTooltip && 'is-tooltip'
  );
  const _iconStyles = useThemeStyles<IIconStyles>(undefined, [iconStylesInfo, ...singleOrArrayToArray(iconStyles)]);
  return (
    <div {...elementProps} ref={ref} className={classNames.root}>
      <div className={classNames.icon}>
        {isTooltip ? (
          <TooltipHost {...tooltipHostProps} content={children as JSX.Element}>
            <Icon iconName={iconName} styles={_iconStyles} />
          </TooltipHost>
        ) : (
          <Icon iconName={iconName} styles={_iconStyles} />
        )}
      </div>
      {!isTooltip && <div className={classNames.text}>{children}</div>}
    </div>
  );
});
